import AppConfig from "./config/AppConfig.json";
import Overview from "./config/PagesConfig/Overview.json";
import Detail from "./config/PagesConfig/Detail.json";
import Insights from "./config/PagesConfig/Insights.json";

export default class Config {
  static getAllPagesConfig() {
    return new Promise((resolve) => {
      const appConfig = this.getPageConfig("app", AppConfig);
      const overviewConfig = this.getPageConfig("overview", Overview);
      const detailConfig = this.getPageConfig("detail", Detail);
      const insightsConfig = this.getPageConfig("insights", Insights);

      Promise.all([
        appConfig,
        overviewConfig,
        detailConfig,
        insightsConfig,
      ]).then((values) => {
        const config = {};
        for (let i = 0; i < values.length; i += 1) {
          const item = values[i];
          config[item.configName] = item;
        }
        resolve(config);
      });
    });
  }

  static getPageConfig(name, file) {
    return new Promise((resolve) => {
      file.configName = name;
      resolve(file);
    });
  }
}
